(function ($) {
    function applyColorTitles() {
        if (!window.colorPaletteMap) return;

        $('.iris-palette').each(function () {
            const bg = $(this).css('background-color').replace(/\s+/g, '');

            const match = colorPaletteMap.find(item => item.color.replace(/\s+/g, '') === bg);
            if (match) {
                const $attr = match.name + ' ' + match.hex;
                $(this).attr('title', $attr);
            }
        });
    }

    if (typeof acf !== 'undefined') {
        acf.addAction('ready_field/type=color_picker', applyColorTitles);
        acf.addAction('append_field/type=color_picker', applyColorTitles);
    }

    $(document).on('click', '.wp-color-result', function () {
        setTimeout(applyColorTitles, 100);
    });

})(jQuery);